export default __webpack_public_path__ + "static/media/setslifespark.90ef06dc.png";